import axios from "../helpers/axios";

// declarar state
const state = {
  nuevaEra: "Bienvenido",
  grados: [],
  niveles: [],
};

//declarar getters
const getters = {
  getGrados: (state) => {
    return state.grados;
  },
};

//declarar muttations
const mutations = {
  setGrados(state, payload) {
    state.grados = payload.grados;
  },

  setNiveles(state, payload) {
    state.niveles = payload.niveles;
  },
};

//declarar actions
const actions = {
  async getAllGrados(context) {
    try {
      let response = await axios.get("/manager/gradoCkOne/");
      context.commit("setGrados", {
        grados: response.data,
      });
    } catch (error) {
      console.log(error);
    }
  },

  async getAllNiveles(context) {
    try {
      let response = await axios.get("/manager/nivelCkOne/");
      context.commit("setNiveles", {
        niveles: response.data,
      });
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
